import { isEmpty, pipe, toString, split, reduce, append, slice } from 'ramda'

export default (pastedData, limit = null) => {
  if (!pastedData || isEmpty(pastedData)) return []
  return pipe(
    split(/\s|(?:,| )+|\n/),
    reduce((a, n) => {
      const thing = split('\t', n)
      return thing.length && thing[0] ? append(thing[0], a) : a
    }, []),
    limit ? slice(0, limit) : x => x,
  )(pastedData)
}
